import {ReactElement} from 'react'
import {
  PeopleActive,
  People,
  MyFavorites,
  MyFavoritesActive,
  Notifications,
  NotificationsActive,
  MyMessages,
  MyMessagesActive
} from './icons/icons'

export type SidebarKeys = 'people' | 'favorites' | 'notifications' | 'chats'

export type SidebarItem = {
  id: SidebarKeys
  key: number
  text: string
  linkTo: string
  iconDefault: ReactElement
  iconActive: ReactElement
}

export const bottomMenuItems: Record<SidebarKeys, SidebarItem> = {
  people: {
    id: 'people',
    key: 1,
    text: 'People',
    linkTo: '/people',
    iconDefault: <People />,
    iconActive: <PeopleActive />
  },
  favorites: {
    id: 'favorites',
    key: 2,
    text: 'Favorites',
    linkTo: '/favorites',
    iconDefault: <MyFavorites />,
    iconActive: <MyFavoritesActive />
  },
  notifications: {
    id: 'notifications',
    key: 3,
    text: 'Notifications',
    linkTo: '/notifications',
    iconDefault: <Notifications />,
    iconActive: <NotificationsActive />
  },
  chats: {
    id: 'chats',
    key: 4,
    text: 'Chats',
    linkTo: '/messages',
    iconDefault: <MyMessages />,
    iconActive: <MyMessagesActive />
  }
}

export const bottomMenuList = Object.values(bottomMenuItems)
